import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const ThumbnailUpload = ({ thumbnail, onThumbnailChange, onThumbnailRemove }) => {
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      onThumbnailChange(acceptedFiles[0]);
    }
  }, [onThumbnailChange]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpg', '.jpeg']
    },
    maxFiles: 1,
    multiple: false
  });

  // Check if thumbnail is a string (URL) or a File object
  const isUrl = typeof thumbnail === 'string' && thumbnail.length > 0;
  const isFile = thumbnail instanceof File;
  const hasThumbnail = isUrl || isFile;

  return (
    <div className="thumbnail-upload-container">
      <div 
        {...getRootProps()} 
        className={`dropzone ${isDragActive ? 'active' : ''} ${hasThumbnail ? 'has-thumbnail' : ''}`}
      >
        <input {...getInputProps()} />
        {hasThumbnail ? (
          <div className="thumbnail-preview">
            <img 
              src={isFile ? URL.createObjectURL(thumbnail) : thumbnail} 
              alt="Course thumbnail" 
              className="preview-image"
            />
            <button 
              className="delete-button"
              onClick={(e) => {
                e.stopPropagation();
                onThumbnailRemove();
              }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        ) : (
          <div className="dropzone-content">
            <p>Drag & drop a thumbnail image here, or click to select</p>
            <p className="text-muted">Supports: PNG, JPG, JPEG</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ThumbnailUpload; 